module.exports = __webpack_public_path__ + "static/media/CafelandMobile.9e7145bb.png";